import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import apiendpoints from "../apiendpoints.json";

import {
  IoLogoTwitter,
  IoLogoInstagram,
  IoLogoFacebook,
  IoLogoYoutube,
  IoLogoLinkedin,
} from "react-icons/io5";

function Footer() {
  const emailAddress = "info@equityresearchmart.in";

  const handleEmailClick = (mail) => {
    window.location.href = `mailto:${mail}`;
  };
  const handlePhoneClick = (phone) => {
    window.location.href = `tel:${phone}`;
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <section>
      {/* <div class="bg-[#7fbb00] font-sans min-h-[450px] relative max-w-full mx-auto rounded overflow-hidden p-2">
        <div class="grid lg:grid-cols-2 w-full h-full absolute inset-0">
          <div class="p-4 max-lg:hidden">
            <img
              src="https://readymadeui.com/image-1.webp"
              class="object-cover w-full h-full"
              alt="img"
            />
          </div>

          <div class="flex flex-col items-end justify-center text-right px-8 relative bg-[#262464] rounded-tl-[206px] z-20 before:absolute before:inset-0 before:!left-auto before:bg-[#293587] before:w-2/3 before:rounded-bl-[206px] before:-z-10">
            <h3 class="font-bold sm:text-4xl text-2xl text-yellow-400">
              Expert-Driven Research
            </h3>
            <p class="text-sm text-gray-300 mt-4">
              {" "}
              Our research report are backed by extensive research.
            </p>

            <button
              type="button"
              class="mt-6 bg-[#7fbb00] text-white text-base py-2 px-6 border border-white rounded-full hover:bg-white hover:text-black transition duration-300"
            >
              Book Now
            </button>
          </div>
        </div>
      </div> */}
      <div className=" relative bg-gradient-to-br from-[#01295c] via-slate-900 to-[#000000] pt-4 py-4 border-t-4 border-[#2db928]">
        {/* Footer */}
        <footer className=" max-w-8xl mx-auto  pt-8">
          <div className="container space-y-4 mx-auto px-4">
            <div className="flex flex-wrap text-left lg:text-left">
              <div className="w-full lg:w-6/12 px-4 space-y-6">
                <h4 className="text-4xl font-bold text-white">
                  Keep in <span className="text-accent-light">touch</span>
                </h4>

                 <div className="flex flex-col gap-2 text-sm font-normal text-white">
  <p className="m-0">
    Registered Address: 503, A, Patliputra Mall, Block - B, Exhibition Road, Patna
  </p>
  
  <span
    onClick={() => handleEmailClick(emailAddress)}
    className="underline underline-offset-2 cursor-pointer w-fit"
  >
    Email: {emailAddress}
  </span>
  
  <span
    onClick={() => handlePhoneClick("+919039328982")}
    className="underline underline-offset-2 cursor-pointer w-fit"
  >
    Mobile: +91 90393 28982
  </span>
  
  <span
    onClick={() => handleEmailClick("compliance@equityresearchmart.in")}
    className="underline underline-offset-2 cursor-pointer w-fit"
  >
    Compliance Email: compliance@equityresearchmart.in
  </span>
  
  <p className="m-0">
    SEBI-Registered : INH000016700
  </p>
</div>
                
                <div className="mt-6 flex space-x-4">
                  <span className="hover:text-white text-white hover:shadow-lg hover:shadow-[#FDA512] rounded-full">
                    <IoLogoTwitter />
                  </span>
                  <span className="text-white hover:shadow-lg hover:shadow-[#FDA512] rounded-full">
                    <IoLogoInstagram />
                  </span>
                  <span className="text-white hover:shadow-lg hover:shadow-[#FDA512] rounded-full">
                    <a
                      href="https://www.facebook.com/profile.php?id=61565023105667&mibextid=ZbWKwL"
                      className="text-white "
                      target="_blank"
                    >
                      <IoLogoFacebook />
                    </a>
                  </span>
                  <span className="text-white hover:shadow-lg hover:shadow-[#FDA512] rounded-full">
                    <IoLogoYoutube />
                  </span>
                  <span className="text-white hover:shadow-lg hover:shadow-[#FDA512] rounded-full">
                    <IoLogoLinkedin />
                  </span>
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="flex flex-wrap items-top mb-6 mt-2">
                  <div className="w-full lg:w-4/12 px-4 ml-auto">
                    <span className="block uppercase text-white tracking-[1px] text-md font-semibold">
                      Useful Links
                    </span>
                    <br />
                    <ul className="space-y-2">
                      {/*
                       */}
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-our-process`}
                          onClick={scrollToTop}
                          target="blank"
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block md:pb-2 text-sm">
                            Our Process
                          </p>
                        </Link>
                      </li>

                      <li>
                        <Link
                          onClick={scrollToTop}
                          to={`${apiendpoints.footerlinkurl}/equity-careers`}
                          target="blank"
                          className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"
                        >
                          Careers
                        </Link>
                      </li>

                      <li>
                        <Link
                          onClick={scrollToTop}
                          to={`${apiendpoints.footerlinkurl}/equity-kyc`}
                          target="blank"
                          className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"
                        >
                          KYC
                        </Link>
                      </li>
                      <li>
                        <Link
                          onClick={scrollToTop}
                          to={`${apiendpoints.footerlinkurl}/grievance`}
                          target="blank"
                          className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"
                        >
                          {/* <p className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"> */}
                          Grievance
                          {/* </p> */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          onClick={scrollToTop}
                          to={`${apiendpoints.footerlinkurl}/equity-service-agreement`}
                          target="blank"
                          className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"
                        >
                          Service Agreement
                        </Link>
                      </li>
                      {/* <li>
                      <Link
                        onClick={scrollToTop}
                        to="/service-api" target="blank"
                        className="text-transparent bg-clip-text bg-gradient-to-r  from-green-400 to-blue-400 font-normal block pb-2 text-sm"
                      >
                        Api Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollToTop}
                        to={`${apiendpoints.footerlinkurl}/equity-service-agreement`} target="blank"
                        className="pointer-events-none opacity-50 relative block pb-2 text-sm text-white font-semibold border-b-2 bg-gradient-to-r from-[#7fbb00] to-green-700 p-[1px] hover:from-green-400 hover:to-blue-400 rounded-md text-center"
                      >
                        login
                      </Link>
                    </li> */}
                    </ul>
                  </div>
                  <div className="w-full lg:w-4/12 px-4 mt-5 md:mt-0 ">
                    <span className="block uppercase text-white tracking-[1px] text-md font-semibold ">
                      Other Resources
                    </span>
                    <br />
                    <ul className="space-y-2">
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-aboutus`}
                          target="blank"
                          onClick={scrollToTop}
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block md:pb-2 text-sm">
                            About Us
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-policy/termsandcondition`}
                          target="blank"
                          onClick={scrollToTop}
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm ">
                            Terms &amp; Conditions
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-policy/refund-policy`}
                          target="blank"
                          onClick={scrollToTop}
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm">
                            Refund Policy
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-policy/legal-disclaimer`}
                          target="blank"
                          onClick={scrollToTop}
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm">
                            Legal Disclaimer
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${apiendpoints.footerlinkurl}/equity-process`}
                          target="blank"
                          onClick={scrollToTop}
                        >
                          <p className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm">
                            Contact Us
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          onClick={scrollToTop}
                          to={`${apiendpoints.footerlinkurl}/equity-complaints`}
                          target="blank"
                          className="text-white hover:text-blueGray-800 font-normal block pb-2 text-sm"
                        >
                          Complaint
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <hr className=" opacity-50" />
            <div className="flex flex-wrap justify-center  md:justify-between items-center px-2">
              <div className="text-sm text-white  px-2">
                <Link
                  to={`${apiendpoints.footerlinkurl}/equity-policy/termsandcondition`}
                  target="blank"
                  onClick={scrollToTop}
                  className="text-white text-center"
                >
                  Terms & Condition |{" "}
                </Link>
                <Link
                  to={`${apiendpoints.footerlinkurl}/equity-policy/legal-disclaimer`}
                  target="blank"
                  className="text-white"
                  onClick={scrollToTop}
                >
                  Legal Disclaimer{" "}
                </Link>
              </div>
              <div className="w-full md:w-4/12 px-2 text-center cursor-pointer text-gray-200 hover:text-gray-800">
                <div className="text-sm text-gray-200 font-semibold py-1">
                  Copyright ©{" "}
                  <span id="get-current-year text-gray-500">2024</span>
                  <a href="" className=" " target="_blank" /> All rights
                  reserved by Equity Research Mart.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
}

export default Footer;
